<template>
  <div>
    <el-form :rules="rules" ref="form" :model="form" label-width="200px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="取水口编号" prop="intakeNum">
            <el-input v-model="form.intakeNum"></el-input>
          </el-form-item>
        </el-col>-->
      </el-row>
    </el-form>
    <div class="btn-box">
      <el-button @click="formesave()" type="primary">保存</el-button>
      <el-button @click="cancelform()" type="success">取消</el-button>
    </div>
  </div>
</template>

<script>
import {
  irrigationplanadd,
  irrigationplanupdate,
} from "../../../../api/irrigated";
import { cloneObj } from "@/utils/utils";

export default {
  name: "projecktpush",
  data() {
    return {
      titleshow: "",
      options: [
        {
          value: "0",
          label: "单一用户取水",
        },
        {
          value: "1",
          label: "多用户公用取水",
        },
        {
          value: "2",
          label: "其它",
        },
      ],
      form: {},
      //表单验证规则
      rules: {
        name: [
          { required: true, message: "请输入用水户名称", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    id: {
      type: Number,
      required: true,
      default: "",
    },
    formlista: {
      type: Object,
      require: false,
    },
  },
  created() {},
  mounted() {
    console.log(this.formlista);
    if (this.formlista.id) {
      this.form = cloneObj(this.formlista);
    } else {
      console.log("bb");
    }
  },

  methods: {
    cancelform() {
      this.form = {};
      this.$emit("closeDialog");
    },
    formesave() {
      this.$refs.form.validate(async (valid) => {
        console.log("aa");

        if (valid) {
          if (this.formlista.id) {
            this.formlista.id = this.id;
            await irrigationplanupdate(this.formlista, this.form);
          } else {
            this.form.id = this.id;
            await irrigationplanadd(this.form);
          }
          this.$message.success("保存成功");
          this.$emit("closeDialog");
        } else {
          this.$message.error("请检查数据");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
